document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".nutrition-stats-section");

  if (!sections.length) return;

  sections.forEach((section) => {
    const overlays = section.querySelectorAll(".media-play-overlay");

    if (!overlays.length) return;

    overlays.forEach((overlay) => {
      overlay.addEventListener("click", function () {

        const type = this.getAttribute("data-video-type");
        const id = this.getAttribute("data-video-id");
        const url = this.getAttribute("data-video-url");

        const container = section.querySelector(".video-container");
        const poster = section.querySelector(".nutrition-media-poster");

        let videoHTML = "";

        if (type === "youtube") {
          videoHTML = `
            <iframe 
              src="https://www.youtube.com/embed/${id}?autoplay=1&mute=1"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen>
            </iframe>
          `;
        } 
        else if (type === "vimeo") {
          videoHTML = `
            <iframe 
              src="https://player.vimeo.com/video/${id}?autoplay=1"
              frameborder="0"
              allow="autoplay; fullscreen"
              allowfullscreen>
            </iframe>
          `;
        } 
        else if (url) {
          videoHTML = `
            <video controls autoplay playsinline>
              <source src="${url}" type="video/mp4">
            </video>
          `;
        }

        if (container) {
          container.innerHTML = videoHTML;
        }

        if (poster) poster.style.display = "none";
        this.style.display = "none";

      });
    });
  });
});